import * as initManager from './initManager';

export default initManager;
